(function(){
    'use strict'; 
    angular.module('Services').service('CreditNoteAuditTrailTable', CreditNoteAuditTrailTable);
    CreditNoteAuditTrailTable.$inject = [
        'TableLiteFactory',
        'AccountingService',
        'toastr',
        '$filter'
    ]; 

    function CreditNoteAuditTrailTable(
        TableLiteFactory,
        AccountingService, 
        toastr,
        $filter
    ){
        return function(param = {}){
            const tableData = {
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    tableMinHeight: '200px'
                },
                headers: [{
                    label: 'DATE', 
                    viewName: 'date', 
                    filterName: 'date', 
                    width: '145px', 
                    filter: {
                        type: 'datePicker', 
                        url: '', 
                        class: 'filter-date', 
                        toModel: '', 
                        fromModel: '', 
                        useArray: true, 
                        onSubmit: function(header){
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function(){
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'USER', 
                    viewName: 'user', 
                    filterName: 'user', 
                    filter: {
                        type: 'text', 
                        placeholder: 'User', 
                        onSubmit: function(header){
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function(){
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'DETAILS', 
                    viewName: 'details',
                    filterName: 'details', 
                    filter: {
                        type: 'text', 
                        placeholder: 'Details', 
                        onSubmit: function(header){
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function(){
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'CHANGE', 
                    viewName: 'change', 
                    filterName: 'change', 
                    filter: {
                        type: 'text', 
                        placeholder: 'Change', 
                        onSubmit: function(header){
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    }, 
                    headerFn: function(){
                        tableActions.sort(this.filterName);
                    }
                }], 
                data: [], 
                onInit: () => {
                    tableActions.sendRequest();
                }
            }; 

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: AccountingService.IssuedCreditNotes.auditLog, 
                callbackFormat: ['success', 'error', 'filter'], 
                postRequestCallback: data => {
                    buildTableData(data);
                }, 
                postRequestErrorCallback: error => {
                    buildTableData(null); 
                    //toastr.error(error, "Error");
                },
                defaultFilters: angular.extend({
                    size: 20, 
                    page: 0, 
                    sort: 'appId,desc', 
                    id: param.id
                }, param.filter || {})
            });

            function buildTableData(data){
                if(!data) { return tableData; }

                tableActions.initializeTableData(data); 
                angular.forEach(data.content, function(item){
                    item.date = $filter('bbaDate')(item.date, true);
                    tableData.data.push(item);
                });
            }

            this.tableData = tableData;
        }
    }
})(); 


// WEBPACK FOOTER //
// ./js/services/tables/accountingTables/CreditNoteAuditTrailTable.js